import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantAuthPolicy = React.lazy(() =>
    import('../TenantAuthPolicy')
);
const tenantAuthPolicyRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_AUTH_POLICY_PAGE,
        element: <TenantAuthPolicy />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantAuthPolicyRoutesRegistry;
